import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';

import FanProtect from '@stubhub/react-fan-protect';

const FanProtectWithLink = ({className}) => {
  const legalLink = (
    <Link to="/legal/?section=fp" target="_blank">
      <FormattedMessage id="common.moreInfo.trustMessage.fanProtect.link" defaultMessage="Restrictions apply." />
    </Link>
  );

  return <FanProtect className={className} legalLink={legalLink} />;
};

FanProtectWithLink.propTypes = {
  /** Additional class name */
  className: PropTypes.string,
};

export default FanProtectWithLink;
